const asyncUrl = async (evt) => {
  const evtObj = await evt;

  const urlParamsParent = new URLSearchParams(
    evtObj.origin + '/' + evtObj.data
  );
  return urlParamsParent;
};

// window.onload = function() {
//     const parentWindow = window.parent;
//     parentWindow.postMessage('load', '*');
// }

function displayMessage(evt) {

    if (evt.data.type === 'PARENT_URL') {
        // Handle the message with the parent URL here
        console.log('Received parent URL:', evt.data.url);
    }   


    // console.log('evt.origin',  JSON.parse(evt.data));
    //   if (evt.data) {
    //     // const urlParamsParent =  new URLSearchParams(evt.origin + '/' + evt.data)
    //     const urlParamsParent = asyncUrl(evt);

    // console.log('urlParamsParent', urlParamsParent, urlParamsParent.get('session'))

    // console.log(
    //   'window.location !== window.parent.location',
    //   window.location,
    //   window.parent.location
    // );

    // if (window.location !== window.parent.location) {
    //   // console.log("urlParamsParent.has('session')",urlParamsParent.has('session'))
    //   // if (urlParamsParent.has('session')) {
    //   // const parsUrls = urlParamsParent.get('session')
    //   console.log('urlParamsParent', evt.data);
    //   const parsUrls = evt.data.url;
    //   if ( typeof parsUrls !== 'undefined' && parsUrls !== null) {
    //     if (parsUrls.includes('session')) {
    //         parsUrls.replaceAll('?session=', '');
    //         console.log('parsUrls', parsUrls);

    //         const tempList = parsUrls.split('_');
    //         const splitList1 = tempList.map((val) => val.replaceAll('-', ' '));
    //         const splitList2 = splitList1.map((val) =>
    //         val.replaceAll('?session=', '')
    //         );
    //         const splitList3 = splitList2.map((val) =>
    //         val.replaceAll('?&session=', '')
    //         );
    //         const splitList = splitList3.map((val) => val.replaceAll('', ''));
    //         console.log('splitList', splitList);

    //         return parsUrls;
    //         // setMaterial({
    //         //   zPrime: splitList[0],
    //         //   ZSec: splitList[1],
    //         //   wood: splitList[2],
    //         //   nature: splitList[3],
    //         //   tile: splitList[4],
    //         //   industrial: splitList[5],
    //         // });
    //     }
    //   }
    // }
//   }
}

// start URL parsing
//  useEffect(() => { // on first load, see if there is a string to grab
export function startupUrlTest(restoreConfigParams) {
  const urlParams = new URLSearchParams(window.location.search);
  // const parentURL = window.parent.location;
//   window.onload = function () {
    window.parent.postMessage({type: "IFRAME_LOADED"}, '*');

    window.addEventListener('message', function (event) {
      if (event.data.type === 'PARENT_URL') {
        // Handle the message with the parent URL here
        // console.log('Received parent URL:', event.data.url);
        displayMessage(event);
        console.log('event.data.url', event.data.url);
        restoreConfigParams(event.data.url);
        }   
      
    });
//   };

//   console.log('urlParams.has("session")', urlParams);
//   //Parse url
//   if (urlParams.has('session')) {
//     console.log('url+', urlParams.get('session'));
//     console.log('url+', urlParams);

//     const parsUrls = urlParams.get('session');
//     const tempList = parsUrls.split('_');
//     const splitList = tempList.map((val) => val.replaceAll('-', ' '));

//     // console.log("url+1", splitList)
//     return parsUrls;
//     // setMaterial({
//     //   zPrime: splitList[0],
//     //   ZSec: splitList[1],
//     //   wood: splitList[2],
//     //   nature: splitList[3],
//     //   tile: splitList[4],
//     //   industrial: splitList[5],
//     // });
//   }
}

// }, [setMaterial])
// }, [])

// useEffect(() => {
export function updateUrlEffect(stringer) {
  // each action of updating page should update url
  // update url with new link
  const parentWindow = window.parent;

  //   const temp = Object.values(material);
  //   const temp2 = temp.map((val) => val.replaceAll(' ', '-'));
  //   const stringer = temp2.join('_');
  let baseUrl;
  let downloadURL;
  const getUrlHost = window.location.hostname;

  if (window.location != window.parent.location) {
    parentWindow.postMessage(stringer, '*');
    downloadURL =
      'https://www.azahner.com/imagelines-visualizer-dev/?session=' + stringer;
  } else {
    if (getUrlHost === 'localhost') {
      // console.log("localhost")
      baseUrl = 'http://localhost:3000';
    } else if (getUrlHost === 'imagewall-v2.web.app/') {
      // console.log("web.app")
      baseUrl = 'https://imagewall-v2.web.app/';
    } else if (getUrlHost === 'https://www.azahner.com/') {
      // console.log("web.app")
      baseUrl = 'https://www.azahner.com/imagelines-visualizer-dev';
    }
    window.history.replaceState('', '', `${baseUrl}/?session=${stringer}`);

    // downloadURL = `${baseUrl}/?session=${stringer}`;
  }
}

// }, [material]);
// window.onload = function() {
//     const parentWindow = window.parent;
//     console.log("hey i think i'm alive", parentWindow);
//     parentWindow.postMessage('Iframe fully loaded', '*');
// }

